<script setup>
    import { useStageStore } from '@/stores/stage';
    import { computed, defineProps } from 'vue'
    import { useI18n } from 'vue-i18n'

    const { t } = useI18n();

    const props = defineProps({
        stage: Object,
        route: String
    })

    const formStorage = useStageStore();
    const pathDetails = computed(() => formStorage.getPathDetailsByStageId(Number(props.route))[0])
</script>

<template>
    <div class="form-path-details" v-if="!stage?.node?.pathHide">
        <span class="form-path-color" :style="`background: ${pathDetails.color}`">&nbsp;</span>
        <p class="form-path-name">
            <span class="sr-only visually-hidden">{{ t('topic') }}: </span>
            {{ pathDetails.name[formStorage.language] }}
        </p>
    </div>
</template>
